// extracted by mini-css-extract-plugin
export default {"form":"GeracaoFaturamento_form__pOK5A","areaBtn":"GeracaoFaturamento_areaBtn__n9hdP","btn":"GeracaoFaturamento_btn__82p7b","btn2":"GeracaoFaturamento_btn2__RF+I+"};